<template>
  <v-card class="transparent" flat max-height="40px">
    <v-list class="transparent">
      <div
        class="text-subtitle-1 font-weight-black d-flex justify-space-between align-center pa-1 mr-1 ml-1"
        v-for="(item, index) in Pedido.embalaje"
        :key="index"
      >
        <span>
          {{ item.TotalEmp | numeral("0,0") }}
          {{ item.Empaque }}</span
        >
        <span>
          {{ item.TotalUni | numeral(item.Unidad === "M2" ? "0,0.00" : "0,0") }}
          {{ item.Unidad }}
        </span>

        <span>
          {{ TotalPeso | numeral("0,0.00") }}
          Kg</span
        >
      </div>
    </v-list>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["Pedido"]),
    TotalPeso() {
      const Pesos = this.Pedido.embalaje.map((x) => x.Peso);
      const initialValue = 0;
      const sumWithInitial = Pesos.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        initialValue
      );

      return sumWithInitial;
    },
  },
};
</script>

<style></style>
